import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn';

const cardVariants = cva(
  [
    'rounded-card border border-border bg-surface shadow-card',
    'transition-[box-shadow,border-color] duration-[var(--duration-fast)]',
  ],
  {
    variants: {
      padding: { none: 'p-0', sm: 'p-3', md: 'p-4', lg: 'p-6' },
      interactive: { true: 'cursor-pointer hover:shadow-md', false: '' },
    },
    defaultVariants: { padding: 'md', interactive: false },
  },
);

export interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, padding, interactive, ...rest },
  ref,
) {
  return <div ref={ref} className={cn(cardVariants({ padding, interactive }), className)} {...rest} />;
});

export interface CardHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export function CardHeader({ title, subtitle, action, className }: CardHeaderProps) {
  return (
    <div className={cn('mb-3 flex items-start justify-between gap-3', className)}>
      <div>
        <div className="text-md font-bold tracking-[-0.01em] text-fg">{title}</div>
        {subtitle ? <div className="mt-0.5 text-sm text-fg-secondary">{subtitle}</div> : null}
      </div>
      {action}
    </div>
  );
}
